import { render, staticRenderFns } from "./admin-promotion.vue?vue&type=template&id=c5c4f648&scoped=true"
import script from "./admin-promotion.vue?vue&type=script&lang=js"
export * from "./admin-promotion.vue?vue&type=script&lang=js"
import style0 from "./admin-promotion.vue?vue&type=style&index=0&id=c5c4f648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c4f648",
  null
  
)

export default component.exports